export default "__VITE_ASSET__f7a674be__"